<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="服务标识"
                ><a-input v-model="queryParam.code" placeholder="服务标识"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否停用">
                <a-select
                  v-model="queryParam.isHalt"
                  placeholder="请选择"
                  allowClear
                >
                  <a-select-option value="F">正常</a-select-option>
                  <a-select-option value="T">停用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced"> </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button class="button-margin-left" @click="rest"
                  >重置</a-button
                >
                <a-button
                  class="button-margin-left"
                  type="primary"
                  icon="plus"
                  @click="add"
                  v-hasAnyPermission="`service:add`"
                  >新建</a-button
                >
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
        :scroll="{ x: 2000 }"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag class="render-tag" color="grey" v-if="record.isHalt == 'T'"
              >已停用</a-tag
            >
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'api')"
              v-hasAnyPermission="`service:interface`"
              >接口管理</a
            >
            <a
              class="a-action"
              @click="action(record, 'edit')"
              v-hasAnyPermission="`service:edit`"
              >编辑</a
            >
            <a-popconfirm
              title="确认删除?"
              @confirm="action(record, 'del')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`service:delete`"
              ><a class="a-action">删除</a></a-popconfirm
            >
          </template>
        </span>
      </s-table>
    </a-card>

    <system-service-info
      ref="info"
      @success="$refs.table.refresh(true)"
    ></system-service-info>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";
import SystemServiceInfo from "./SystemServiceInfo.vue";

export default {
  name: "SystemServiceList",
  components: {
    STable,
    PageView,
    SystemServiceInfo
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        sort: "list_order"
      },
      // 表头
      columns: [
        {
          title: "服务标识",
          dataIndex: "code",
          scopedSlots: { customRender: "tagItem" },
          fixed: "left",
          width: 280
        },
        {
          title: "名称",
          dataIndex: "descript",
          fixed: "left",
          width: 280
        },
        {
          title: "服务id",
          dataIndex: "serviceId",
          fixed: "left",
          width: 120
        },
        {
          title: "服务url",
          dataIndex: "url"
        },
        {
          title: "匹配路径",
          dataIndex: "route"
        },
        {
          title: "排序",
          dataIndex: "listOrder"
        },
        {
          title: "操作人",
          dataIndex: "modifyUser"
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime",
          width: 120
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          width: 180,
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.systemBksApi
          .pageSystemService(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {},
  methods: {
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "edit") {
        this.$refs.info.showModal(type, Object.assign({}, record));
      } else if (type == "del") {
        this.$http.systemBksApi
          .removeSystemServiceById({ id: record.id })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$message.success(res.msg);
            }
          });
      } else if (type == "api") {
        this.go(record);
      }
    },
    add() {
      this.$refs.info.showModal("add", null);
    },
    go(info) {
      this.$router.push({
        name: "SystemServiceApiList",
        query: {
          code: info.code,
          descript: info.descript,
          serviceId: info.serviceId,
          url: info.url,
          route: info.route
        }
      });
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    rest() {
      this.queryParam = {
        sort: "list_order"
      };
    }
  }
};
</script>
